import moment from "moment";
import { useLocation } from "react-router-dom";
import { AskAiMeetingEmbedFragmentFragment } from "types/graphql-schema";
import { TFLocationState } from "types/topicflow";

import Avatars from "@components/avatar/avatars";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import {
  assertEdgesNonNullWithStringId,
  formatTime,
  getUrlUsingTypename,
  removeCurrentYear,
} from "@helpers/helpers";
import { pluralize } from "@helpers/string";

import AskAILink from "./ask-ai-link";

const AskAIEmbedMeeting = ({
  meeting,
}: {
  meeting: AskAiMeetingEmbedFragmentFragment;
}) => {
  const location = useLocation<TFLocationState>();
  const participantUsers = assertEdgesNonNullWithStringId(
    meeting.participants,
  ).map((participant) => participant.user);
  const topicCount = meeting.topics?.totalCount || 0;
  return (
    <div className="">
      <div className="flex gap-2 items-center">
        <TopicflowIcon type="meeting" className="w-4 h-4 text-gray-400" />
        <div className="flex-1 font-medium">
          <AskAILink
            to={getUrlUsingTypename(meeting, location)}
            className="hover:underline"
          >
            {meeting.title}
          </AskAILink>
        </div>
        <Avatars users={participantUsers} max={5} modalTitle="Participants" />
      </div>
      <div className="ml-6 mt-1 flex items-center gap-1">
        {meeting.startDatetime && meeting.endDatetime ? (
          <span>
            {removeCurrentYear(moment(meeting.startDatetime).format("ll"))},{" "}
            {formatTime(moment(meeting.startDatetime).format("h:mma"))}-
            {formatTime(moment(meeting.endDatetime).format("h:mma"))}
          </span>
        ) : (
          <span>Unscheduled</span>
        )}
        <span className="text-gray-500">&bull;</span>
        <span className="text-gray-500">
          {topicCount} {pluralize("topic", topicCount)}
        </span>
      </div>
    </div>
  );
};

export default AskAIEmbedMeeting;
